import m from "../../geodata/es2015/slovakiaHigh";
window.am4geodata_slovakiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/slovakiaHigh.js
// module id = null
// module chunks = 